import React, { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  useTable,
  useGlobalFilter,
  useAsyncDebounce,
  useSortBy,
  useFilters,
  useExpanded,
  usePagination,
} from "react-table";
import { Table, Row, Col, Button, Input, CardBody } from "reactstrap";
import { Filter, DefaultColumnFilter } from "./filters";
import JobListGlobalFilter from "./GlobalSearchFilter";
import { Link } from "react-router-dom";
import CellEditor from "./CellEditor";
import LocationIdCell from "./LocationIdCell";
import LocationNameCell from "./LocationNameCell";

// Define a default UI for filtering
function GlobalFilter({
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
  isJobListGlobalFilter
}) {
  const count = preGlobalFilteredRows.length;
  const [value, setValue] = React.useState(globalFilter);
  const onChange = useAsyncDebounce(value => {
    setGlobalFilter(value || undefined);
  }, 200);

  return (
    <React.Fragment>
      <Col md={4}>
        <div className="search-box me-xxl-2 my-3 my-xxl-0 d-inline-block">
          <div className="position-relative">
            <label htmlFor="search-bar-0" className="search-label">
              <span id="search-bar-0-label" className="sr-only">
                Search this table
              </span>
              <input
                onChange={e => {
                  setValue(e.target.value);
                  onChange(e.target.value);
                }}
                id="search-bar-0"
                type="text"
                className="form-control"
                placeholder={`${count} records...`}
                value={value || ""}
              />
            </label>
            <i className="bx bx-search-alt search-icon"></i>
          </div>
        </div>

      </Col>
      {isJobListGlobalFilter && (
        <JobListGlobalFilter />
      )}

    </React.Fragment>
  );
}

const LocationTableContainerForTemplate = ({
  columns,
  data,
  isGlobalFilter,
  isJobListGlobalFilter,
  isAddOptions,
  editRow,
  editingRow,
  customPageSize,
  className,
  customPageSizeOptions,
  refreshTable,
  mapDisabled,
  toggleModal,
  loading,
  mapToTemplate,
  currentTemplate

}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      defaultColumn: { Filter: DefaultColumnFilter },
      initialState: {
        pageIndex: 0,
        pageSize: customPageSize,
       
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination
  );

  const [showFilter, setShowFilter] = useState(true)
  const toggleFilter = () => {
    setShowFilter(!showFilter)
  }

  useEffect(() => {
    setSelectedLoc([])
    setSelectedName([])
  }, [])


  const generateSortingIndicator = column => {
    return column.isSorted ? (column.isSortedDesc ? " 🔽" : " 🔼") : "";
  };

  const onChangeInSelect = event => {
    setPageSize(Number(event.target.value));
  };

  const refreshMe = () => {
    setSelectedLoc([])
    refreshTable()
  }

  const maptoCurrentTemplate = () => {
    mapToTemplate(selectedLoc, selectedLocName)
  }

  const confirmDelete = () => {
    toggleModal()
  }

  const onChangeInInput = event => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const [selectedLoc, setSelectedLoc] = useState([])
  const [selectedLocName, setSelectedName] = useState([])

  const handleCheck = (row) => {
    
    const m_loc_id = row.original.m_loc_id;
    const m_loc_nm = row.original.tLocationName

    if (selectedLoc?.includes(m_loc_id)) {
        const newSelectedLocs = selectedLoc.filter((item, index) => item !== m_loc_id)
        const newSelectedLocNames = selectedLocName.filter((item, index) => item !== m_loc_nm)
        setSelectedLoc(newSelectedLocs)
        setSelectedName(newSelectedLocNames)
    } else {
       var newSelectedLocs = [...selectedLoc]
       newSelectedLocs.push(m_loc_id)
       var newSelectedLocNames = [...selectedLocName]
       newSelectedLocNames.push(m_loc_nm)
       setSelectedLoc(newSelectedLocs)
       setSelectedName(newSelectedLocNames)
    }
    
}

  return (
    <Fragment>
      <Row className="mb-2">
        <Col md={customPageSizeOptions ? 2 : 2}>
          <select
            className="form-select"
            value={pageSize}
            onChange={onChangeInSelect}
          >
            {[10, 20, 30, 40, 50].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </Col>
        {isGlobalFilter && (
          <GlobalFilter
            preGlobalFilteredRows={preGlobalFilteredRows}
            globalFilter={state.globalFilter}
            setGlobalFilter={setGlobalFilter}
            isJobListGlobalFilter={isJobListGlobalFilter}
          />
        )}
        {isAddOptions && (
          <Col>
            <div className="text-sm-end">
            <Button type="button" className="btn btn-soft-primary btn-sm waves-effect waves-light me-2" color='primary' disabled={selectedLoc.length == 0} onClick={maptoCurrentTemplate}>
              Map to template
            </Button>
            <Link to="#" onClick={refreshMe}>
              <i className="fas fa-sync-alt" />
            </Link>
              
            </div>
          </Col>
        )}
       
        
      </Row>

      <div className="table-responsive react-table">
        <Table bordered hover {...getTableProps()} className={className}>
          <thead className="table-light table-nowrap">
            {headerGroups.map(headerGroup => (
              <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th key={column.id}>
                    <div className="mb-2" {...column.getSortByToggleProps()}>
                      {column.render("Header")}
                      {generateSortingIndicator(column)}
                    </div>
                    {showFilter && <Filter column={column} />}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
         
          <tbody {...getTableBodyProps()}>
          {loading && <div>Loading....</div>}
            {!loading && page.map(row => {
              prepareRow(row);
              return (
                <Fragment key={row.getRowProps().key}>
                  <tr>
                  
                    {row.cells.map(cell => {
                      // {console.log(cell)}
                      return (

                       
                        <td key={cell.id} {...cell.getCellProps()} style={cell.column.style} >
                        {cell.column.id==='m_loc_id' &&  <input
                        type="checkbox"
                        className="form-check-input"
                        id="customControlInline"
                        disabled={row.original.templateName?.length>0 || row.original.templateName === currentTemplate}
                        // checked={row.original.templateName == currentTemplate? true: false}
                        onChange={() => {handleCheck(row)}}
                      />} 
                        {cell.column.id !=='m_loc_id' && cell.render("Cell")} 
                        </td>
                      );
                    })}
                  </tr>
                 
                </Fragment>
              );
            })}
          </tbody>
        </Table>
      </div>

      <Row className="justify-content-md-end justify-content-center align-items-center">
        <Col className="col-md-auto">
          <div className="d-flex gap-1">
            <Button
              color="primary"
              onClick={() => gotoPage(0)}
              disabled={!canPreviousPage}
            >
              {"<<"}
            </Button>
            <Button
              color="primary"
              onClick={previousPage}
              disabled={!canPreviousPage}
            >
              {"<"}
            </Button>
          </div>
        </Col>
        <Col className="col-md-auto d-none d-md-block">
          Page{" "}
          <strong>
            {pageIndex + 1} of {pageOptions.length}
          </strong>
        </Col>
        <Col className="col-md-auto">
          <Input
            type="number"
            min={1}
            style={{ width: 70 }}
            max={pageOptions.length}
            defaultValue={pageIndex + 1}
            onChange={onChangeInInput}
          />
        </Col>

        <Col className="col-md-auto">
          <div className="d-flex gap-1">
            <Button color="primary" onClick={nextPage} disabled={!canNextPage}>
              {">"}
            </Button>
            <Button
              color="primary"
              onClick={() => gotoPage(pageCount - 1)}
              disabled={!canNextPage}
            >
              {">>"}
            </Button>
          </div>
        </Col>
      </Row>
    </Fragment>
  );
};

LocationTableContainerForTemplate.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default LocationTableContainerForTemplate;
